import React from 'react';

import { Modal } from 'src/components/common';
import { InvitePeoStaffByPeoPayrollProviderModalForm } from 'src/components/peoStaff';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import type { InvitePeoStaffByPeoPayrollProviderModalArgs } from './types';

export const InvitePeoStaffByPeoPayrollProviderModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } =
    useModal<InvitePeoStaffByPeoPayrollProviderModalArgs>(
      ModalId.InvitePeoStaffByPeoPayrollProviderModal,
    );

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Invite PEO Staff"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      maxWidth={740}
    >
      <InvitePeoStaffByPeoPayrollProviderModalForm
        peoId={args?.peoId}
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
